<script>
import AppIcon from "@/features/general/Icons";

export default {
  name: "AppCashbackBalanceCard",

  components: {
    AppIcon,
  },

  props: {
    balance: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    /**
     * Formata valor em centavos para moeda BRL.
     * @param {number} cents valor em centavos
     * @return {string}
     */
    formatCurrency(cents) {
      return (cents / 100).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },

    /**
     * Formata data ISO para exibição no padrão brasileiro.
     * @param {string} isoDate data no formato ISO
     * @return {string}
     */
    formatDate(isoDate) {
      if (!isoDate) {
        return "";
      }

      return new Date(isoDate).toLocaleDateString("pt-BR");
    },
  },

  computed: {
    /**
     * Indica se existe valor de expiração próxima a exibir.
     * @return {boolean}
     */
    hasUpcomingExpiration() {
      return (
        !!this.balance.next_expiration_at &&
        this.balance.next_expiration_amount_cents > 0
      );
    },

    /**
     * Indica se existe saldo em carência a exibir.
     * @return {boolean}
     */
    hasPendingBalance() {
      return this.balance.pending_cents > 0;
    },

    /**
     * Texto de liberação do saldo em carência.
     * @return {string}
     */
    pendingReleaseLabel() {
      if (this.balance.next_pending_available_at) {
        return `Liberação automática até ${this.formatDate(this.balance.next_pending_available_at)}.`;
      }

      return "Liberação automática D+7.";
    },
  },
};
</script>

<template>
  <div class="app__cashback__balance-card mb-4">
    <p class="app__cashback__balance-card__header-label">Seu saldo de cashback</p>

    <div class="d-flex align-items-baseline gap-3 mb-0">
      <span
        class="app__cashback__balance-card__available-amount"
        :class="{ app__loading: loading }"
      >
        {{ formatCurrency(balance.available_cents) }}
      </span>
      <span class="app__cashback__balance-card__available-badge">
        <app-icon name="check-circle" prefix="fa" />
        disponível agora
      </span>
    </div>

    <div
      v-if="hasPendingBalance || hasUpcomingExpiration"
      class="app__cashback__balance-card__cells"
    >
      <div v-if="hasPendingBalance" class="app__cashback__balance-card__cell">
        <span class="app__cashback__balance-card__info-label">
          <app-icon name="clock" prefix="fa" />
          Em carência
        </span>
        <span
          class="app__cashback__balance-card__info-amount"
          :class="{ app__loading: loading }"
        >
          {{ formatCurrency(balance.pending_cents) }}
        </span>
        <span class="app__cashback__balance-card__info-meta">
          {{ pendingReleaseLabel }}
        </span>
      </div>

      <div v-if="hasUpcomingExpiration" class="app__cashback__balance-card__cell">
        <span class="app__cashback__balance-card__info-label">
          <app-icon name="exclamation-triangle" prefix="fa" />
          Próxima expiração
        </span>
        <span
          class="app__cashback__balance-card__info-amount"
          :class="{ app__loading: loading }"
        >
          {{ formatDate(balance.next_expiration_at) }}
        </span>
        <span class="app__cashback__balance-card__info-meta">
          {{ formatCurrency(balance.next_expiration_amount_cents) }} vencem nesta data.
        </span>
      </div>
    </div>
  </div>
</template>
